import { RestServiceUtils } from '../utils/RestServiceUtils';

const tagService = {
    addTag: (organizationId, placeId, payload) => {
        const URL = `/ums/${organizationId}/${placeId}/tag`;
        return RestServiceUtils.HTTP_POST(URL, payload, {}, false);
    },

    getAllTags: (organizationId, placeId, params) => {
        const URL = `/ums/${organizationId}/${placeId}/tag`;
        return RestServiceUtils.HTTP_GET(URL, params);
    },

    getTagById: (organizationId, placeId, tagId) => {
        const URL = `/ums/${organizationId}/${placeId}/tag/${tagId}`;
        return RestServiceUtils.HTTP_GET(URL);
    },

    deleteTags: (organizationId, placeId, tagIds) => {
        const URL = `/ums/${organizationId}/${placeId}/tag`;
        return RestServiceUtils.HTTP_DELETE(URL, tagIds);
    },

    regenerateKey: (organizationId, placeId, tagId) => {
        const URL = `/ums/${organizationId}/${placeId}/tag/${tagId}/regenerateKey`;
        return RestServiceUtils.HTTP_PUT(URL);
    },
};

export default tagService;
